import { useTranslation } from 'react-i18next';
import SVGIcon, { IIcons } from '../../../components/atoms/icons';
import type { FormularioAberturaOrdemServicoProps } from '../types';

export const problemIcons: {
	id: number;
	label: string;
	iconName: string;
	iconColor: string;
	twoIconColor: string;
	backgroundColor: string;
	iconeSvg: IIcons;
}[] = [
	{ id: 2, label: 'CoolingDown', iconName: 'warning-amber', iconColor: '#000', twoIconColor: '#000', backgroundColor: '#EFFF3ADE', iconeSvg: 'Coolingdown' },
	{ id: 3, label: 'Defrost', iconName: 'highlight-off', iconColor: '#000', twoIconColor: '#000', backgroundColor: '#FF0000', iconeSvg: 'Defrost2' },
	{ id: 4, label: 'Problema Crítico', iconName: 'notification-important', iconColor: '#FF0000', twoIconColor: '#FF0000', backgroundColor: '#1E1E1E', iconeSvg: 'Alert' },
	{ id: 6, label: 'Sem Alimentação', iconName: 'power-off', iconColor: '#EFFF3ADE', twoIconColor: '#E1DD03', backgroundColor: '#353535', iconeSvg: 'NoEnergy' },
	{ id: 8, label: 'Falta de Energia', iconName: 'outlet', iconColor: '#00BCDE', twoIconColor: '#00BCDE', backgroundColor: '#1E1E1E', iconeSvg: 'Socket' },
	{ id: 10, label: 'Manutenção Preventiva', iconName: 'home-repair-service', iconColor: '#FFF', twoIconColor: '#6A5ACD', backgroundColor: '#6A5ACD', iconeSvg: 'Maintenance' },
	{ id: 12, label: 'Baixo Rendimento', iconName: 'warning-amber', iconColor: '#000', twoIconColor: '#000', backgroundColor: '#EFFF3ADE', iconeSvg: 'Error' },
	{ id: 13, label: 'Temperatura Crítica', iconName: 'highlight-off', iconColor: '#FFFFFF', twoIconColor: '#000', backgroundColor: '#FF0000', iconeSvg: 'X' },
];

const FormularioAberturaOrdemServico = ({
	containerPainel,
	containerSelecionado,
	formularioOrdemServico,
	problemaContainer,
	classeAlertaTemperatura,
	erroCriacaoOrdemServico,
	carregandoCriacaoOrdemServico,
	aoVoltar,
	aoAlterarCampo,
	aoAlterarCategoriaProblema,
	aoCriarOrdemServico,
}: FormularioAberturaOrdemServicoProps) => {
	const { t } = useTranslation();
	const ordensServico = problemaContainer?.['ordens-servico'] || [];
	const containerFormulario = containerSelecionado?.label || containerPainel;

	return (
	<section className="mx-auto max-w-5xl px-6 py-6">
		<p className="mb-7 font-mono text-xs text-[#64748b]">
			{t('fluxo_unico.breadcrumb.email')} › {t('fluxo_unico.breadcrumb.record')} ›
			<span className="text-[#2f70f0]"> {t('fluxo_unico.breadcrumb.new_report')}</span>
		</p>

		<div className="flex items-center gap-4">
			<button
				aria-label={t('fluxo_unico.form.back_panel')}
				className="flex size-8 items-center justify-center rounded-md border border-[#cbd5e1] bg-white transition-colors hover:border-[#2f70f0] hover:bg-[#f8fafc] focus:outline-none focus:ring-2 focus:ring-[#bfdbfe]"
				onClick={aoVoltar}
				title={t('fluxo_unico.form.back_panel')}
				type="button"
			>
				<SVGIcon
					className="h-2 w-3 fill-[#475569]"
					direction="left"
					icon="Arrow"
				/>
			</button>
			<h1 className="text-3xl font-bold tracking-normal">
				{t('fluxo_unico.breadcrumb.new_report')}
			</h1>
		</div>
		<p className="mt-1 text-sm text-[#64748b]">
			{t('fluxo_unico.form.container')}: {containerFormulario} - {containerSelecionado?.carrier}
		</p>

		<div className="mt-8 rounded-md border border-[#93c5fd] bg-[#eff6ff] p-4">
			<p className="flex align-center text-sm font-semibold text-[#1d4ed8]">
				<span><SVGIcon
					className="mr-2 size-4 [&_path]:fill-[#1d4ed8]"
					icon="Container"
				/></span>{t('fluxo_unico.form.pre_filled_data')}
			</p>
			<p className="mt-1 text-xs text-[#64748b]">
				{t('fluxo_unico.form.pre_filled_description')}
			</p>
		</div>

		<form
			className="mt-5"
			onSubmit={aoCriarOrdemServico}
		>
			<div className="rounded-lg border border-[#d9e1ea] bg-white p-7 shadow-sm">
				<h2 className="mb-7 font-semibold text-[#1f2937]">
					📊 {t('fluxo_unico.form.alert_data')}
				</h2>

				<div className="space-y-5">
					<div className="grid gap-5 md:grid-cols-3">
						<label className="block text-sm font-semibold">
							<span className="mb-2 block">
								{t('fluxo_unico.form.container')}
							</span>
							<input
								className="h-11 w-full rounded-md border border-[#cbd5e1] bg-[#f8fafc] px-3 text-[#64748b] disabled:cursor-not-allowed disabled:opacity-80"
								disabled
								value={containerFormulario}
							/>
						</label>

						<label className="block text-sm font-semibold">
							<span className="mb-2 block">
								{t('fluxo_unico.form.serial')}
							</span>
							<input
								className="h-11 w-full rounded-md border border-[#cbd5e1] bg-white px-3 text-[#1f2937] outline-none focus:border-[#2f70f0] focus:ring-2 focus:ring-[#dbeafe]"
								name="serial"
								onChange={aoAlterarCampo}
								type="text"
								value={formularioOrdemServico.serial}
							/>
						</label>

						<label className="block text-sm font-semibold">
							<span className="mb-2 block">
								{t('fluxo_unico.form.size')}
							</span>
							<input
								className="h-11 w-full rounded-md border border-[#cbd5e1] bg-white px-3 text-[#1f2937] outline-none focus:border-[#2f70f0] focus:ring-2 focus:ring-[#dbeafe]"
								name="tamanho"
								onChange={aoAlterarCampo}
								type="text"
								value={formularioOrdemServico.tamanho}
							/>
						</label>
					</div>

					<div className="grid gap-5 md:grid-cols-4">
						<label className="block text-sm font-semibold">
							<span className="mb-2 block">
								{t('fluxo_unico.form.model')}
							</span>
							<input
								className="h-11 w-full rounded-md border border-[#cbd5e1] bg-white px-3 text-[#1f2937] outline-none focus:border-[#2f70f0] focus:ring-2 focus:ring-[#dbeafe]"
								name="modelo"
								onChange={aoAlterarCampo}
								type="text"
								value={formularioOrdemServico.modelo}
							/>
						</label>

						<label className="block text-sm font-semibold">
							<span className="mb-2 block">
								{t('fluxo_unico.form.gas')}
							</span>
							<input
								className="h-11 w-full rounded-md border border-[#cbd5e1] bg-white px-3 text-[#1f2937] outline-none focus:border-[#2f70f0] focus:ring-2 focus:ring-[#dbeafe]"
								name="gas"
								onChange={aoAlterarCampo}
								type="text"
								value={formularioOrdemServico.gas}
							/>
						</label>

						<label className="block text-sm font-semibold">
							<span className="mb-2 block">
								{t('fluxo_unico.form.qty')}
							</span>
							<input
								className="h-11 w-full rounded-md border border-[#cbd5e1] bg-white px-3 text-[#1f2937] outline-none focus:border-[#2f70f0] focus:ring-2 focus:ring-[#dbeafe]"
								name="quantidade"
								onChange={aoAlterarCampo}
								type="text"
								value={formularioOrdemServico.quantidade}
							/>
						</label>

						<label className="block text-sm font-semibold">
							<span className="mb-2 block">
								{t('fluxo_unico.form.manufacture_date')}
							</span>
							<input
								className="h-11 w-full rounded-md border border-[#cbd5e1] bg-white px-3 text-[#1f2937] outline-none focus:border-[#2f70f0] focus:ring-2 focus:ring-[#dbeafe]"
								name="dataFabricacao"
								onChange={aoAlterarCampo}
								type="date"
								value={formularioOrdemServico.dataFabricacao}
							/>
						</label>
					</div>

					<label className="block text-sm font-semibold">
						<span className="mb-2 block">
							{t('fluxo_unico.form.damage_description')}
						</span>
						<textarea
								className="min-h-24 w-full rounded-md border border-[#cbd5e1] bg-white p-3 text-[#1f2937] outline-none focus:border-[#2f70f0] focus:ring-2 focus:ring-[#dbeafe]"
							name="descricaoDano"
							onChange={aoAlterarCampo}
							value={formularioOrdemServico.descricaoDano}
						/>
					</label>

					<div className="block text-sm font-semibold">
						<span className="mb-2 block">
							{t('fluxo_unico.form.problem_category')}
						</span>
						<div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
							{problemIcons.map((problema) => {
								const estaSelecionado =
									formularioOrdemServico.categoriaProblema.includes(problema.id);

								return (
									<button
										aria-pressed={estaSelecionado}
										className={`flex min-h-16 items-center gap-3 rounded-md border px-3 py-2 text-left transition-colors focus:outline-none focus:ring-2 focus:ring-[#bfdbfe] ${
											estaSelecionado
												? 'border-[#2f70f0] bg-[#eff6ff]'
												: 'border-[#cbd5e1] bg-white hover:border-[#2f70f0]'
										}`}
										key={problema.id}
										onClick={() => aoAlterarCategoriaProblema(problema.id)}
										type="button"
									>
										<span
											className="flex size-10 shrink-0 items-center justify-center rounded-md"
											style={{ backgroundColor: problema.backgroundColor }}
										>
											<SVGIcon
												className="size-5"
												icon={problema.iconeSvg}
												style={{
													fill: problema.iconColor,
													color: problema.iconColor,
													stroke: problema.iconColor,
												}}
											/>
										</span>
										<span className="min-w-0">
												<span className="block break-words text-sm font-semibold text-[#1f2937]">
												{problema.label}
											</span>
												<span className="mt-1 block font-mono text-xs text-[#64748b]">
												#{problema.id}
											</span>
										</span>
									</button>
								);
							})}
						</div>
					</div>

					<div>
						<label className="flex w-fit cursor-pointer items-center gap-3 text-sm font-semibold">
							<input
								checked={formularioOrdemServico.retificacao}
								className="size-4 accent-[#2f70f0]"
								name="retificacao"
								onChange={aoAlterarCampo}
								type="checkbox"
							/>
							{t('fluxo_unico.form.rectification')}
						</label>

						<label className="mt-4 block text-sm font-semibold">
							<span className="mb-2 block">
								{t('fluxo_unico.form.rectified_report')}
							</span>
							<select
								className="h-11 w-full rounded-md border border-[#cbd5e1] bg-white px-3 text-[#1f2937] outline-none focus:border-[#2f70f0] focus:ring-2 focus:ring-[#dbeafe] disabled:cursor-not-allowed disabled:opacity-80"
								disabled={!formularioOrdemServico.retificacao}
								name="idOrdemServicoRetificada"
								onChange={aoAlterarCampo}
								required={formularioOrdemServico.retificacao}
								value={formularioOrdemServico.idOrdemServicoRetificada}
							>
								<option value="">
									{t('fluxo_unico.form.select_report')}
								</option>
								{ordensServico.map((ordemServico) => (
									<option key={ordemServico.id} value={ordemServico.id}>
										RAT - #{ordemServico.id}
									</option>
								))}
							</select>
						</label>
					</div>

					<label className="block text-sm font-semibold">
						<span className="mb-2 block">
							{t('fluxo_unico.form.detection_date_time')}
						</span>
						<input
							className="h-11 w-full rounded-md border border-[#cbd5e1] bg-[#f8fafc] px-3 text-[#64748b] disabled:cursor-not-allowed disabled:opacity-80"
							name="dataDeteccao"
							onChange={aoAlterarCampo}
							type="text"
							value={formularioOrdemServico.dataDeteccao}
							disabled
						/>
					</label>

					<label className="block text-sm font-semibold">
						<span className="mb-2 block">
							{t('fluxo_unico.form.configured_set_point')}
						</span>
						<input
							className="h-11 w-full rounded-md border border-[#cbd5e1] bg-white px-3 text-[#1f2937] outline-none focus:border-[#2f70f0] focus:ring-2 focus:ring-[#dbeafe]"
							name="setPoint"
							onChange={aoAlterarCampo}
							type="number"
							value={formularioOrdemServico.setPoint}
						/>
					</label>

					<label className="block text-sm font-semibold">
						<span className="mb-2 block">
							{t('fluxo_unico.form.alert_temperature')}
						</span>
						<input
							className={`h-11 w-full rounded-md border px-3 outline-none transition-colors ${classeAlertaTemperatura}`}
							name="temperatura"
							onChange={aoAlterarCampo}
							type="number"
							value={formularioOrdemServico.temperatura}
						/>
					</label>

					<div>
						<p className="mb-2 text-sm font-semibold">
							{t('fluxo_unico.form.registered_evidence')}
						</p>
						<div className="rounded-md border border-[#d9e1ea] bg-[#f8fafc] p-4">
							{problemaContainer?.images?.length ? (
								<div className="flex gap-4 overflow-x-auto pb-2">
									{problemaContainer.images.map(
										(imagem, indice) => (
											<a
											className="group shrink-0 overflow-hidden rounded-md border border-[#cbd5e1] bg-white transition-colors hover:border-[#2f70f0]"
												href={imagem}
												key={imagem}
												rel="noreferrer"
												target="_blank"
												title={t('fluxo_unico.form.open_evidence', { number: indice + 1 })}
											>
												<img
													alt={t('fluxo_unico.form.registered_evidence_alt', { number: indice + 1 })}
													className="h-28 w-40 object-cover transition-transform group-hover:scale-105"
													src={imagem}
												/>
											<p className="px-3 py-2 font-mono text-xs text-[#64748b]">
													{t('fluxo_unico.form.photo', { number: indice + 1 })}
												</p>
											</a>
										)
									)}
								</div>
							) : (
								<div className="flex min-h-28 items-center justify-center rounded bg-white font-mono text-sm text-[#64748b]">
									{t('fluxo_unico.form.no_photo')}
								</div>
							)}
							<p className="mt-4 text-xs text-[#64748b]">
								{t('fluxo_unico.form.monitoring_image_notice')}
							</p>
						</div>
					</div>
				</div>
			</div>

			{erroCriacaoOrdemServico && (
				<p className="mt-5 rounded-md border border-[#ef4444] bg-[#fff1f2] px-4 py-3 text-sm font-semibold text-[#dc2626]">
					{erroCriacaoOrdemServico}
				</p>
			)}

			<div className="mt-7 flex flex-wrap gap-4 border-t border-[#e2e8f0] pt-7">
				<button
					className="rounded-md border border-[#cbd5e1] bg-white px-5 py-3 font-semibold text-[#475569] transition-colors hover:border-[#94a3b8] hover:bg-[#f8fafc]"
					onClick={aoVoltar}
					type="button"
				>
					{t('fluxo_unico.form.cancel')}
				</button>
				<button
					className="rounded-md border border-[#2f70f0] bg-[#2f70f0] px-5 py-3 font-semibold text-white transition-colors hover:bg-[#245dcc] disabled:cursor-not-allowed disabled:opacity-70"
					disabled={carregandoCriacaoOrdemServico}
					type="submit"
				>
					{carregandoCriacaoOrdemServico
						? t('fluxo_unico.form.creating_os')
						: t('fluxo_unico.form.confirm_os')}
				</button>
			</div>
		</form>
	</section>
	);
};

export default FormularioAberturaOrdemServico;
